import React from 'react';
import { Check } from 'lucide-react';

interface ImageAdjustOverlayProps {
  dragging?: boolean;
  instructionText?: string;
  onExit?: () => void;
}

const ImageAdjustOverlay: React.FC<ImageAdjustOverlayProps> = ({
  dragging = false,
  instructionText = 'Drag to reposition | Scroll to zoom',
  onExit,
}) => {
  return (
    <div className="pointer-events-none absolute inset-0 z-[31]">
      <div className="absolute inset-[12px] rounded-[18px] border border-white/85 shadow-[0_0_0_1px_rgba(59,130,246,0.9),0_0_0_9999px_rgba(15,23,42,0.24)]" />
      <div className="absolute inset-[12px] rounded-[18px] bg-gradient-to-b from-white/8 via-transparent to-black/10" />
      <div className="absolute left-1/2 top-[12px] h-[calc(100%-24px)] w-px -translate-x-1/2 bg-white/35" />
      <div className="absolute left-[12px] top-1/2 h-px w-[calc(100%-24px)] -translate-y-1/2 bg-white/35" />
      <div className="absolute left-3 top-3 rounded-full border border-white/70 bg-black/65 px-3 py-1 text-[11px] font-medium text-white shadow-sm">
        Adjust Image
      </div>
      <button
        type="button"
        data-builder-allow-interaction
        className="pointer-events-auto absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-white/70 bg-black/65 px-3 py-1 text-[11px] font-medium text-white shadow-sm transition hover:bg-black/75"
        onPointerDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onExit?.();
        }}
      >
        <Check className="h-3.5 w-3.5" />
        <span>Done</span>
      </button>
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full border border-white/60 bg-black/60 px-3 py-1 text-[11px] text-white/95 shadow-sm">
        {instructionText}
      </div>
      <div
        className={`absolute inset-[12px] rounded-[18px] transition ${
          dragging ? 'ring-2 ring-blue-300/80' : 'ring-1 ring-white/20'
        }`}
      />
    </div>
  );
};

export default ImageAdjustOverlay;
